import { HStack, Text } from '@chakra-ui/react';
import React from 'react';

import SearchInput from '@/components/search-input/SearchInput';
import { LIGHT_BOLD_FONT_WEIGHT, NUMERICAL_ONE, NUMERICAL_ZERO } from '@/constants/defaults';
import { FULL_WIDTH } from '@/constants/ui';
import { ELEMENT_DATA_TEST_IDS } from '@/tests/testConstants';

interface TableHeaderProps {
  handleFilter: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder: string;
}

const TableHeader = (props: TableHeaderProps): React.JSX.Element => {
  const { handleFilter = () => void {}, label = '', placeholder = '' } = props;

  return (
    <HStack alignItems="center" gap={2} justifyContent="flex-start" p={NUMERICAL_ONE} width={FULL_WIDTH}>
      <Text color={'black'} flexShrink={NUMERICAL_ZERO} fontWeight={LIGHT_BOLD_FONT_WEIGHT} whiteSpace="nowrap">
        {label}
      </Text>

      <SearchInput
        data-testid={ELEMENT_DATA_TEST_IDS.TABLE_HEADER_SEARCH}
        onChange={handleFilter}
        placeholder={placeholder}
        size="sm"
        variant={'outline'}
        width="100%"
      />
    </HStack>
  );
};

export default TableHeader;
